import { SUCCESS_CODE } from '@/constants'
import { ResTableColumnsItem, getOpenApiCategoryListResItem } from '@/api/dataService/index'
import Mock from 'mockjs'

export default [
  // 获取表字段
  {
    url: '/mock/v1/open-api/table/columns',
    method: 'get',
    response: () => {
      const tableColumns: ResTableColumnsItem[] = Array.from({ length: 10 }).map((_, index) => ({
        paramName: Mock.mock('@protocol'),
        paramType: index + 'string',
        paramDesc: Mock.mock('@csentence(3, 5)')
      }))
      return {
        code: SUCCESS_CODE,
        data: tableColumns
      }
    }
  },
  //  数据服务- 数据服务类目-获取列表
  {
    url: '/mock/v1/api/category/list',
    method: 'get',
    response: () => {
      const tableColumns: getOpenApiCategoryListResItem[] = Array.from({ length: 10 }).map(
        (_, index) => ({
          id: `${index}`,
          parentId: 0,
          level: 0,
          count: 10,
          label: Mock.mock('@csentence(3, 5)'),
          children: [
            {
              id: `1-${index}`,
              parentId: 1,
              level: 1,
              count: 2,
              label: Mock.mock('@csentence(3, 5)'),
              children: [
                {
                  id: `2-${index}`,
                  parentId: 2,
                  level: 2,
                  count: 2,
                  label: Mock.mock('@csentence(3, 5)')
                },
                {
                  id: `3-${index}`,
                  parentId: 2,
                  level: 2,
                  count: 2,
                  label: Mock.mock('@csentence(3, 5)')
                }
              ]
            },
            {
              id: `4-${index}`,
              parentId: 0,
              level: 1,
              count: 2,
              label: Mock.mock('@csentence(3, 5)')
            }
          ]
        })
      )
      return {
        code: SUCCESS_CODE,
        data: tableColumns
      }
    }
  }
]
